import React from 'react';
import View from '@loggi/ui/components/view';
import Text from '@loggi/ui/components/text';
import Icon from '@loggi/ui/components/icon';
import Col from '@loggi/ui/components/col';
import classNames from '@loggi/classnames';
import haystack from '@loggi/ui/components/typeahead/utils/haystack';
import { addressHasNumber } from '../address';
import styles from './styles.scss';

export const NUMBER_MASK = 'número';
const ADDRESS_MAPPER = {
  avenida: 'Av.',
  rua: 'R.',
  alameda: 'Al.',
  viaduto: 'Viad.',
  parque: 'Pq.'
};

export function abbreviateWords(word = '', mapper = ADDRESS_MAPPER) {
  if (typeof word !== 'string') {
    return word;
  }

  Object.keys(mapper).forEach(regex => {
    word = word.replace(new RegExp(regex, 'ig'), mapper[regex]);
  });

  if (word.endsWith(', Brasil')) {
    word = word.replace(/, Brasil$/, '');
  }

  return word;
}

export function renderSuggestion(suggestion, { value, suggestionIndex }) {
  const icon = suggestion.icon ? (
    <View inline className={styles.icon}>
      <Icon {...suggestion.icon} />
    </View>
  ) : null;

  const { mainText = '', secondaryText = '' } = suggestion.structuredFormatting;
  const abbreviatedMain = abbreviateWords(mainText, ADDRESS_MAPPER);
  const abbreviatedSecond = abbreviateWords(secondaryText, ADDRESS_MAPPER);

  if (__NATIVE__) {
    const main = haystack(
      abbreviatedMain,
      abbreviateWords(value, ADDRESS_MAPPER)
    );

    const containerStyle = classNames({
      item: true,
      noBorder: suggestionIndex === 0
    }).flatten(styles);

    return (
      <Col
        gutter={{ top: 'normal', bottom: 'normal', left: 'double' }}
        style={containerStyle}
      >
        <View inline>
          {icon}
          {main}
        </View>
        <Text small>{abbreviatedSecond}</Text>
      </Col>
    );
  }

  // TODO(@renatoagds) remove this and use native approach
  const normal = haystack(abbreviatedMain, value);
  const lighter = haystack(abbreviatedSecond, value);
  const content = {
    __html: `<span>${normal} - <span class="${
      styles.lighter
    }">${lighter}</span></span>`
  };

  return (
    <View>
      {icon}
      <View inline dangerouslySetInnerHTML={content} />
    </View>
  );
}

export function getSuggestionValue(suggestion, ignoreNumber = false) {
  const { mainText = '', secondaryText = '' } = suggestion.structuredFormatting;
  const isGooglePremise =
    suggestion.types && suggestion.types.includes('premise');

  const address = abbreviateWords(
    isGooglePremise ? secondaryText : mainText,
    ADDRESS_MAPPER
  );

  if (ignoreNumber || isGooglePremise) {
    return address;
  }

  return addressHasNumber(address) ? address : `${address}, ${NUMBER_MASK}`;
}
